export default {
  install(Vue) {
    Vue.prototype.$gtm = (event, params = {}) => {
      console.log(
        `%cData Layer PUSH! Event: ${event}`,
        "color: pink",
        "🌈🌚 🌝💨",
        params
      );

      if (!window.dataLayer) {
        console.warn("[GTM] dataLayer not found");
        return;
      }

      window.dataLayer.push({ event, ...params });
    };
  },
};
